import {Link, useMatch, useNavigate} from 'react-router-dom'
import {useTranslation} from 'react-i18next'

import {KTSVG} from '../../../../../_metronic/helpers'
import {useIsMobile} from '../../../../shared/responsive'

const ReportLink = ({activeMatch, iconPath, meta, mobile = false, title, to}) => {
  const active = useMatch(activeMatch)

  if (mobile) {
    return (
      <Link to={to} className={`reports-mobile-link ${active ? 'active' : ''}`.trim()}>
        <span className='reports-mobile-link__icon'>
          <KTSVG path={iconPath} className='svg-icon svg-icon-2' />
        </span>
        <span className='reports-mobile-link__copy'>
          <span className='reports-mobile-link__title'>{title}</span>
          <span className='reports-mobile-link__meta'>{meta}</span>
        </span>
        <span className='reports-mobile-link__chevron'>
          <KTSVG path='/media/icons/duotune/arrows/arr024.svg' className='svg-icon svg-icon-2' />
        </span>
      </Link>
    )
  }

  return (
    <Link to={to} end className={`reports-desktop-link ${active ? 'active' : ''}`.trim()}>
      <span className='reports-desktop-link__icon'>
        <KTSVG path={iconPath} className='svg-icon svg-icon-2' />
      </span>
      <span className='reports-desktop-link__copy'>
        <span className='reports-desktop-link__title'>{title}</span>
      </span>
      <span className='reports-desktop-link__chevron'>
        <KTSVG path='/media/icons/duotune/arrows/arr024.svg' className='svg-icon svg-icon-2' />
      </span>
    </Link>
  )
}

const NDVIReport = ({mobile = false}) => {
  const {t} = useTranslation()

  return (
    <ReportLink
      activeMatch='/gis/reports/ndvi/*'
      iconPath='/media/icons/duotune/graphs/gra011.svg'
      meta={t('reports:selector.ndvi_report_meta')}
      mobile={mobile}
      title={t('reports:selector.ndvi_report')}
      to='/gis/reports/ndvi'
    />
  )
}

const TechnicalReport = ({mobile = false}) => {
  const {t} = useTranslation()

  return (
    <ReportLink
      activeMatch='/gis/reports/technical/*'
      iconPath='/media/icons/duotune/files/fil003.svg'
      meta={t('reports:selector.technical_report_meta')}
      mobile={mobile}
      title={t('reports:selector.technical_report')}
      to='/gis/reports/technical'
    />
  )
}

const EconomicReport = ({mobile = false}) => {
  const {t} = useTranslation()

  return (
    <ReportLink
      activeMatch='/gis/reports/economic/*'
      iconPath='/media/icons/duotune/finance/fin010.svg'
      meta={t('reports:selector.economic_report_meta')}
      mobile={mobile}
      title={t('reports:selector.economic_report')}
      to='/gis/reports/economic'
    />
  )
}

const ReportsSelector = () => {
  const {t} = useTranslation()
  const navigate = useNavigate()
  const isMobile = useIsMobile()

  if (isMobile) {
    return (
      <div className='reports-mobile-shell displayable'>
        <div className='card shadow-sm right-card-data reports-mobile-card'>
          <div className='reports-mobile-card__header'>
            <button
              type='button'
              className='btn btn-sm btn-light reports-mobile-card__back'
              onClick={() => navigate('/gis', {state: {keepDrawerOpen: true}})}
            >
              <KTSVG
                path='/media/icons/duotune/arrows/arr063.svg'
                className='svg-icon svg-icon-2'
              />
              <span>{t('common:navigation.back_home')}</span>
            </button>
            <h2 className='reports-mobile-card__title'>{t('reports:selector.title')}</h2>
          </div>

          <div className='reports-mobile-card__body'>
            <NDVIReport mobile />
            <TechnicalReport mobile />
            <EconomicReport mobile />
          </div>
        </div>
      </div>
    )
  }

  return (
    <>
      <div className='card shadow-sm field-view-container displayable right-card-data reports-desktop-card'>
        <div className='card-header collapsible reports-desktop-card__header'>
          <h4
            className='card-title cursor-pointer reports-desktop-card__title'
            data-bs-toggle='collapse'
            data-bs-target='#kt_reports_selector'
          >
            {t('reports:selector.title')}
          </h4>
        </div>
        <div id='kt_reports_selector' className='collapse show'>
          <div className={`card-body p-0`}>
            <NDVIReport />
            <TechnicalReport />
            <EconomicReport />
          </div>
        </div>
      </div>
    </>
  )
}

const ReportsSelectorContainer = () => {
  return (
    <>
      <div className='d-flex flex-column flex-row-auto field-view-flex-container'>
        <div className='d-flex flex-column-auto'>
          <ReportsSelector />
        </div>
      </div>
    </>
  )
}

export default ReportsSelectorContainer
